import { Button } from '@dev-spendesk/grapes';
import { type ReactNode } from 'react';

import { useTranslation } from 'src/core/common/hooks/useTranslation';

import type { InconsistencyModalItemBase } from '../../models';
import { InconsistencyModal } from '../InconsistencyModal';
import { type Labels } from '../InconsistencyModal/InconsistencyModal';

type Props<T extends InconsistencyModalItemBase> = {
  isOpen: boolean;
  items: T[];
  labels: Labels;
  renderItemSummary: (item: T) => ReactNode;
  onCancel: () => void;
  onContinue: () => void;
  onClose: () => void;
};

export const ConfirmInconsistencyModal = <
  T extends InconsistencyModalItemBase,
>({
  isOpen,
  items,
  labels,
  renderItemSummary,
  onCancel,
  onContinue,
  onClose,
}: Props<T>) => {
  const { t } = useTranslation('global');

  const buttons = [
    <Button
      key="cancel"
      text={t('inconsistencyModal.confirm.cancel')}
      variant="secondaryNeutral"
      onClick={onCancel}
    />,
    <Button
      key="continue"
      text={t('inconsistencyModal.confirm.continue')}
      variant="primaryBrand"
      onClick={onContinue}
    />,
  ];
  return (
    <InconsistencyModal<T>
      buttons={buttons}
      isOpen={isOpen}
      items={items}
      labels={labels}
      renderItemSummary={renderItemSummary}
      onClose={onClose}
    />
  );
};
